import { createContext, useContext, useEffect, useState } from "react";
import { ActualLangContext } from "../../../contexts/ActualLangContext";
import { frameworkDataEs, frameworkDataEn } from "../mockData/frameworkData";

const AIFrameworkContext = createContext({});

const SOLUTIONS_AREAS = [
  "Framework",
];
const EN_SOLUTIONS_AREAS = [
  "Framework",
];

export const AIFrameworkProvider = ({ children }) => {
  const { actualLang } = useContext(ActualLangContext);

  const [isLoadingSolutions, setIsLoadingSolutions] = useState(true);
  const [solutions, setSolutions] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [selectedSolution, setSelectedSolution] = useState("");

  useEffect(() => {
    const loadSolutions = () => {
      try {
        setIsLoadingSolutions(true);
        
        // Usar datos mock directamente
        const mockData = actualLang === 'en' ? frameworkDataEn : frameworkDataEs;
        
        const mappedData = SOLUTIONS_AREAS.map((area, idx) => ({
          area,
          textArea: actualLang === "es" ? area : EN_SOLUTIONS_AREAS[idx],
          solutions: mockData.data
            .filter((sol) => sol?.attributes?.area === area)
            .map((sol) => ({
              topTitle: sol?.attributes?.topTitle || "Sin título",
              items: sol?.attributes?.items || [],
            })),
        }));
        
        setSolutions(mappedData);
        if (mappedData.length > 0) {
          setSelectedArea(mappedData[0].area);
          setSelectedSolution(mappedData[0].solutions[0].topTitle);
        }
      } finally {
        setIsLoadingSolutions(false);
      }
    };

    loadSolutions();
  }, [actualLang]);

  return (
    <AIFrameworkContext.Provider
      value={{
        isLoadingSolutions,
        solutions,
        selectedArea,
        selectedSolution,
        setSelectedArea,
        setSelectedSolution,
        SOLUTIONS_AREAS,
      }}
    >
      {children}
    </AIFrameworkContext.Provider>
  );
};

export const useAIFrameworkContext = () => {
  return useContext(AIFrameworkContext);
};
